import { Quaternion } from "@babylonjs/core/Maths/math.vector";
import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { Wall as toolWall, MoveWall } from './tools';
import { AbstractInteractors } from "./interactors";
import { EditWalls } from "../cmd/EditWalls";
import { Util } from "../utils/Util";
import { WallEnding, WallSide } from "../mdl/Wall";
import { WallSnapping } from "./WallSnapping";
import { InteractorType } from '@egr/wcf/modules/core/tool';
import { PI_DIV2 } from "@egr/wcf/modules/utils/math";
import { VECTOR3_X, perpendicularVector2 } from "@egr/wcf/modules/core/utils/MathUtils";
import { getRotationQuaternion } from "@egr/wcf/modules/core/utils/MeshUtils";
export class WallInteractors extends AbstractInteractors {
    constructor(pRoomManager, pWall) {
        super(pRoomManager);
        this.mWall = pWall;
        this.mLengthInteractors = [null, null, null, null, null, null];
        this.mAddInteractorS = null;
        this.mAddInteractorE = null;
    }
    showInteractors(pShow) {
        this.clear();
        if (!pShow || this.mApp.model.selection.length !== 1)
            return;
        this.mInteractorManager.enabled = true;
        let tCenter = Vector2.Center(this.mWall.startPoint, this.mWall.endPoint);
        let t3dRotation = getRotationQuaternion(this.mWall.node).clone();
        t3dRotation.multiplyInPlace(Quaternion.RotationAxis(VECTOR3_X, PI_DIV2));
        this._updateLengthInteractors();
        //this.createSideIndicators(t3dRotation);
        //move start
        let tInteractor = this.createInteractor("dot-interactor", Util.to3d(this.mWall.startPoint), null, 0, t3dRotation);
        tInteractor.onTriggerAction = () => this.startMoveWall(WallSnapping.Mode.MoveStart, this.mWall.startPoint);
        //move end
        tInteractor = this.createInteractor("dot-interactor", Util.to3d(this.mWall.endPoint), null, 0, t3dRotation);
        tInteractor.onTriggerAction = () => this.startMoveWall(WallSnapping.Mode.MoveEnd, this.mWall.endPoint);
        //move wall
        tInteractor = this.createInteractor("move-interactor", Util.to3d(tCenter), null, 0, t3dRotation);
        tInteractor.onTriggerAction = () => this.startMoveWall(WallSnapping.Mode.MoveWall, tCenter);
        //if (!this.mRoomManager._deviceHasMouse())
        this._updateAddInteractors();
    }
    clear() {
        this.mInteractorManager.clear();
        if (this.mAddInteractorS != null)
            this.mInteractorManager.removeInteractor(this.mAddInteractorS);
        if (this.mAddInteractorE != null)
            this.mInteractorManager.removeInteractor(this.mAddInteractorE);
        this.mInteractorManager.enabled = false;
        this.mLengthInteractors = [null, null, null, null, null, null];
    }
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    _updateLengthInteractors() {
        this.mInteractorManager.enabled = true;
        let tDir = this.mWall.endPoint.subtract(this.mWall.startPoint);
        let tDirP = perpendicularVector2(tDir);
        let t3dRotation = getRotationQuaternion(this.mWall.node).clone();
        t3dRotation.multiplyInPlace(Quaternion.RotationAxis(VECTOR3_X, PI_DIV2));
        //length left
        let tSideCenter = Vector2.Center(this.mWall._edges[2], this.mWall._edges[3]);
        let tSideLengthL = this.mWall.getWallLength_B();
        let tInteractorL = this.createTextInteractor(Util.to3d(tSideCenter), "[b]   " + this.lengthToString(tSideLengthL) + Util.getLengthUnitString(this.mRoomManager.app.i18n.lengthUnit), Util.to3d(tDir).normalize(), Util.to3d(tDirP).normalize(), -14, t3dRotation, false, this.mLengthInteractors[0]);
        tInteractorL.onTriggerAction = () => this.showInputField(WallInteractors.INPUT_LENGTH_L, tSideLengthL, tInteractorL, this.mWall);
        tInteractorL.element.onmouseenter = () => this._mouseEnter(this.mRoomManager, tInteractorL.element.firstChild);
        tInteractorL.element.onmouseleave = () => this._mouseLeave(this.mRoomManager, tInteractorL.element.firstChild);
        this.mLengthInteractors[0] = tInteractorL;
        //length right
        tSideCenter = Vector2.Center(this.mWall._edges[0], this.mWall._edges[1]);
        let tSideLengthR = this.mWall.getWallLength_A();
        let tInteractorR = this.createTextInteractor(Util.to3d(tSideCenter), "[a]   " + this.lengthToString(tSideLengthR) + Util.getLengthUnitString(this.mRoomManager.app.i18n.lengthUnit), Util.to3d(tDir).normalize(), Util.to3d(tDirP).normalize(), 14, t3dRotation, false, this.mLengthInteractors[1]);
        tInteractorR.onTriggerAction = () => this.showInputField(WallInteractors.INPUT_LENGTH_R, tSideLengthR, tInteractorR, this.mWall);
        tInteractorR.element.onmouseenter = () => this._mouseEnter(this.mRoomManager, tInteractorR.element.firstChild);
        tInteractorR.element.onmouseleave = () => this._mouseLeave(this.mRoomManager, tInteractorR.element.firstChild);
        this.mLengthInteractors[1] = tInteractorR;
        this.updateDistTextInteractors();
    }
    /** @internal */
    _updateAddInteractors() {
        //if (!this.mRoomManager.touchDevice || this.mRoomManager._deviceHasMouse())
        //    return;
        if (!this.mInteractorManager.enabled)
            return;
        if (this.mAddInteractorS != null)
            this.mInteractorManager.removeInteractor(this.mAddInteractorS);
        if (this.mAddInteractorE != null)
            this.mInteractorManager.removeInteractor(this.mAddInteractorE);
        let t3dRotation = getRotationQuaternion(this.mWall.node).clone();
        t3dRotation.multiplyInPlace(Quaternion.RotationAxis(VECTOR3_X, PI_DIV2));
        //add new walls
        // start
        //if (this.mWall.startCxn.wall == null) {
        this.mAddInteractorS = this.createInteractor("plus-interactor", Util.to3d(this.mWall.startPoint), Util.to3d(this.mWall.wallDirection), -50, t3dRotation, true, false);
        this.mAddInteractorS.onTriggerAction = () => this.startAddWall(WallSnapping.Mode.MoveStart, this.mWall.startPoint, this.mWall);
        //}
        // end
        //if (this.mWall.endCxn.wall == null) {
        this.mAddInteractorE = this.createInteractor("plus-interactor", Util.to3d(this.mWall.endPoint), Util.to3d(this.mWall.wallDirection), 50, t3dRotation, true, false);
        this.mAddInteractorE.onTriggerAction = () => this.startAddWall(WallSnapping.Mode.MoveEnd, this.mWall.endPoint, this.mWall);
        //}
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    handleInputField(pId, pOldLength, pNewLength, pInteractor) {
        switch (pId) {
            case WallInteractors.INPUT_LENGTH_L:
                if (pNewLength >= 0.01)
                    this.setWallLength(pNewLength, true, pInteractor);
                break;
            case WallInteractors.INPUT_LENGTH_R:
                if (pNewLength >= 0.01)
                    this.setWallLength(pNewLength, false, pInteractor);
                break;
            case WallInteractors.INPUT_DIST_S_L:
                this.setNeighbourDistance(WallEnding.Start, WallSide.Left, pOldLength, pNewLength, pInteractor._negateDir);
                break;
            case WallInteractors.INPUT_DIST_S_R:
                this.setNeighbourDistance(WallEnding.Start, WallSide.Right, pOldLength, pNewLength, pInteractor._negateDir);
                break;
            case WallInteractors.INPUT_DIST_E_L:
                this.setNeighbourDistance(WallEnding.End, WallSide.Left, pOldLength, pNewLength, pInteractor._negateDir);
                break;
            case WallInteractors.INPUT_DIST_E_R:
                this.setNeighbourDistance(WallEnding.End, WallSide.Right, pOldLength, pNewLength, pInteractor._negateDir);
                break;
            default:
                break;
        }
        this.mRoomManager.findRoom();
    }
    _mouseEnter(pRoomManager, pSpanElement) {
        let tStyle = pSpanElement.style;
        tStyle.color = pRoomManager.app.theme.mainColorBright;
    }
    _mouseLeave(pRoomManager, pSpanElement) {
        let tStyle = pSpanElement.style;
        tStyle.color = "#4f4f4f";
    }
    createSideIndicators(p3dRotation) {
        let tWallDir = this.mWall.endPoint.subtract(this.mWall.startPoint);
        let tWallDirP = perpendicularVector2(tWallDir);
        let tDir = this.mWall._edges[1].subtract(this.mWall._edges[0]);
        let tPos = this.mWall._edges[0].add(tDir.scale(0.05));
        let tInteractor = this.createTextInteractor(Util.to3d(tPos), "a", Util.to3d(tWallDir).normalize(), Util.to3d(tWallDirP).normalize(), 14, p3dRotation, true);
        tInteractor.type = InteractorType.None;
        tDir = this.mWall._edges[3].subtract(this.mWall._edges[2]);
        tPos = this.mWall._edges[3].subtract(tDir.scale(0.05));
        tInteractor = this.createTextInteractor(Util.to3d(tPos), "b", Util.to3d(tWallDir).normalize(), Util.to3d(tWallDirP).normalize(), -14, p3dRotation, true);
        tInteractor.type = InteractorType.None;
    }
    // tslint:disable-next-line:cyclomatic-complexity
    updateDistTextInteractors() {
        if (this.mWall.startCxn.wall != null) {
            let tWall = this.mWall.startCxn.wall;
            let tDir = tWall.endPoint.subtract(tWall.startPoint).normalize();
            let tDirP = perpendicularVector2(tDir);
            let tOffset = 14;
            if (tWall.isWallOnLeftSide(this.mWall))
                tOffset = -14;
            //3d rotation matrix
            let t3dRotation = getRotationQuaternion(tWall.node).clone();
            t3dRotation.multiplyInPlace(Quaternion.RotationAxis(VECTOR3_X, PI_DIV2));
            let tNDist = this.mWall._getNeighbourDistance(WallEnding.Start, WallSide.Left);
            if (tNDist != null) {
                let tDistance = tNDist.distance;
                let tOffsetDir = tDirP;
                if (tNDist.negateDir)
                    tOffsetDir = tOffsetDir.negate();
                let tCenter = Vector2.Center(tNDist.refPos2, tNDist.refPos1);
                if (tDistance > 0.01) {
                    let tInteractor = this.createTextInteractor(Util.to3d(tCenter), this.lengthToString(tDistance) + Util.getLengthUnitString(this.mRoomManager.app.i18n.lengthUnit), Util.to3d(tDir).normalize(), Util.to3d(tOffsetDir).normalize(), tOffset, t3dRotation, false, this.mLengthInteractors[2]);
                    tInteractor.onTriggerAction = () => this.showInputField(WallInteractors.INPUT_DIST_S_L, tDistance, tInteractor, tWall);
                    tInteractor._negateDir = tNDist.negateDir;
                    tInteractor.element.onmouseenter = () => this._mouseEnter(this.mRoomManager, tInteractor.element.firstChild);
                    tInteractor.element.onmouseleave = () => this._mouseLeave(this.mRoomManager, tInteractor.element.firstChild);
                    this.mLengthInteractors[2] = tInteractor;
                }
            }
            tNDist = this.mWall._getNeighbourDistance(WallEnding.Start, WallSide.Right);
            if (tNDist != null) {
                let tDistance = tNDist.distance;
                let tOffsetDir = tDirP;
                if (tNDist.negateDir)
                    tOffsetDir = tOffsetDir.negate();
                let tCenter = Vector2.Center(tNDist.refPos2, tNDist.refPos1);
                if (tDistance > 0.01) {
                    let tInteractor = this.createTextInteractor(Util.to3d(tCenter), this.lengthToString(tDistance) + Util.getLengthUnitString(this.mRoomManager.app.i18n.lengthUnit), Util.to3d(tDir).normalize(), Util.to3d(tOffsetDir).normalize(), tOffset, t3dRotation, false, this.mLengthInteractors[3]);
                    tInteractor.onTriggerAction = () => this.showInputField(WallInteractors.INPUT_DIST_S_R, tDistance, tInteractor, tWall);
                    tInteractor._negateDir = tNDist.negateDir;
                    tInteractor.element.onmouseenter = () => this._mouseEnter(this.mRoomManager, tInteractor.element.firstChild);
                    tInteractor.element.onmouseleave = () => this._mouseLeave(this.mRoomManager, tInteractor.element.firstChild);
                    this.mLengthInteractors[3] = tInteractor;
                }
            }
        }
        else {
            if (this.mLengthInteractors[2] != null) {
                this.mInteractorManager.removeInteractor(this.mLengthInteractors[2]);
                this.mLengthInteractors[2] = null;
            }
            if (this.mLengthInteractors[3] != null) {
                this.mInteractorManager.removeInteractor(this.mLengthInteractors[3]);
                this.mLengthInteractors[3] = null;
            }
        }
        if (this.mWall.endCxn.wall != null) {
            let tWall = this.mWall.endCxn.wall;
            let tDir = tWall.endPoint.subtract(tWall.startPoint).normalize();
            let tDirP = perpendicularVector2(tDir);
            let tOffset = 14;
            if (tWall.isWallOnLeftSide(this.mWall))
                tOffset = -14;
            //3d rotation matrix
            let t3dRotation = getRotationQuaternion(tWall.node).clone();
            t3dRotation.multiplyInPlace(Quaternion.RotationAxis(VECTOR3_X, PI_DIV2));
            let tNDist = this.mWall._getNeighbourDistance(WallEnding.End, WallSide.Left);
            if (tNDist != null) {
                let tDistance = tNDist.distance;
                let tOffsetDir = tDirP;
                if (tNDist.negateDir)
                    tOffsetDir = tOffsetDir.negate();
                let tCenter = Vector2.Center(tNDist.refPos2, tNDist.refPos1);
                if (tDistance > 0.01) {
                    let tInteractor = this.createTextInteractor(Util.to3d(tCenter), this.lengthToString(tDistance) + Util.getLengthUnitString(this.mRoomManager.app.i18n.lengthUnit), Util.to3d(tDir).normalize(), Util.to3d(tOffsetDir).normalize(), tOffset, t3dRotation, false, this.mLengthInteractors[4]);
                    tInteractor.onTriggerAction = () => this.showInputField(WallInteractors.INPUT_DIST_E_L, tDistance, tInteractor, tWall);
                    tInteractor._negateDir = tNDist.negateDir;
                    tInteractor.element.onmouseenter = () => this._mouseEnter(this.mRoomManager, tInteractor.element.firstChild);
                    tInteractor.element.onmouseleave = () => this._mouseLeave(this.mRoomManager, tInteractor.element.firstChild);
                    this.mLengthInteractors[4] = tInteractor;
                }
            }
            tNDist = this.mWall._getNeighbourDistance(WallEnding.End, WallSide.Right);
            if (tNDist != null) {
                let tDistance = tNDist.distance;
                let tOffsetDir = tDirP;
                if (tNDist.negateDir)
                    tOffsetDir = tOffsetDir.negate();
                let tCenter = Vector2.Center(tNDist.refPos2, tNDist.refPos1);
                if (tDistance > 0.01) {
                    let tInteractor = this.createTextInteractor(Util.to3d(tCenter), this.lengthToString(tDistance) + Util.getLengthUnitString(this.mRoomManager.app.i18n.lengthUnit), Util.to3d(tDir).normalize(), Util.to3d(tOffsetDir).normalize(), tOffset, t3dRotation, false, this.mLengthInteractors[5]);
                    tInteractor.onTriggerAction = () => this.showInputField(WallInteractors.INPUT_DIST_E_R, tDistance, tInteractor, tWall);
                    tInteractor._negateDir = tNDist.negateDir;
                    tInteractor.element.onmouseenter = () => this._mouseEnter(this.mRoomManager, tInteractor.element.firstChild);
                    tInteractor.element.onmouseleave = () => this._mouseLeave(this.mRoomManager, tInteractor.element.firstChild);
                    this.mLengthInteractors[5] = tInteractor;
                }
            }
        }
        else {
            if (this.mLengthInteractors[4] != null) {
                this.mInteractorManager.removeInteractor(this.mLengthInteractors[4]);
                this.mLengthInteractors[4] = null;
            }
            if (this.mLengthInteractors[5] != null) {
                this.mInteractorManager.removeInteractor(this.mLengthInteractors[5]);
                this.mLengthInteractors[5] = null;
            }
        }
    }
    startMoveWall(pMode, pStartPosition) {
        let tTool = new MoveWall(this.mRoomManager, pStartPosition);
        tTool.initialize(pMode, this.mWall);
        this.mApp.tools.startTool(tTool);
    }
    startAddWall(pMode, paddPosition, pPrevWall) {
        let tTool = new toolWall(this.mRoomManager, paddPosition, pPrevWall, pMode);
        this.mApp.tools.startTool(tTool);
    }
    setWallLength(pLength, pLeftWallSide, pInteractor) {
        let tScaleInStartDirection = this.mRoomManager.changeWallLengthToRight;
        if (pInteractor.angleFlipped)
            tScaleInStartDirection = !tScaleInStartDirection;
        this.mWall.setWallLength(pLength, pLeftWallSide, tScaleInStartDirection);
    }
    setNeighbourDistance(pEnding, pSide, pOldDist, pDist, pNegateDir) {
        let tCmd = new EditWalls(this.mRoomManager);
        try {
            this.mRoomManager.beginCollectWallUpdates();
            let tDiff = pDist - pOldDist;
            let tCxn = null;
            // ceck conditions
            if (pEnding === WallEnding.Start) {
                if (this.mWall.startCxn.wall == null)
                    return;
                tCxn = this.mWall.startCxn;
            }
            else {
                if (this.mWall.endCxn.wall == null)
                    return;
                tCxn = this.mWall.endCxn;
            }
            if (tCxn.wall == null)
                return;
            let tDir;
            let tVS = tCxn.wall.startPoint;
            let tVE = tCxn.wall.endPoint;
            if (pSide === WallSide.Left) {
                if (tCxn.wall.isWallOnLeftSide(this.mWall))
                    tDir = tVS.subtract(tVE).normalize();
                else
                    tDir = tVE.subtract(tVS).normalize();
            }
            else if (tCxn.wall.isWallOnLeftSide(this.mWall))
                tDir = tVE.subtract(tVS).normalize();
            else
                tDir = tVS.subtract(tVE).normalize();
            if (pNegateDir)
                tDir = tDir.negate();
            let tV = tDir.scale(tDiff);
            let tDirections = this.mWall._getConnectedWallDirections();
            this.mWall.moveWall(tV);
            this.mWall._handleFlippedWalls(tDirections);
            this.mWall._validateConnections(2);
        }
        finally {
            this.mRoomManager.endCollectWallUpdates();
            this.mApp.commands.executeCommand(tCmd);
        }
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
WallInteractors.INPUT_LENGTH_L = "Wall:length_left";
WallInteractors.INPUT_LENGTH_R = "Wall:length_right";
WallInteractors.INPUT_DIST_S_L = "Wall:distance_start_left";
WallInteractors.INPUT_DIST_S_R = "Wall:distance_start_right";
WallInteractors.INPUT_DIST_E_L = "Wall:distance_end_left";
WallInteractors.INPUT_DIST_E_R = "Wall:distance_end_right";
